module.exports = __webpack_public_path__ + "img/frame (263).add54fd9.jpg";